var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H36C37.0609 0 38.0783 0.421427 38.8284 1.17157C39.5786 1.92172 40 2.93913 40 4V28C40 29.0609 39.5786 30.0783 38.8284 30.8284C38.0783 31.5786 37.0609 32 36 32H4C2.93913 32 1.92172 31.5786 1.17157 30.8284C0.421427 30.0783 0 29.0609 0 28V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0ZM4 4V28H36V4H4ZM20 13C20.7956 13 21.5587 13.3161 22.1213 13.8787C22.6839 14.4413 23 15.2044 23 16C23 16.7956 22.6839 17.5587 22.1213 18.1213C21.5587 18.6839 20.7956 19 20 19C19.2044 19 18.4413 18.6839 17.8787 18.1213C17.3161 17.5587 17 16.7956 17 16C17 15.2044 17.3161 14.4413 17.8787 13.8787C18.4413 13.3161 19.2044 13 20 13ZM20 7C24.28 7 27.86 10 28.78 14H25.66C25.2488 12.8281 24.4828 11.8132 23.4686 11.0964C22.4543 10.3796 21.242 9.99641 20 10C17.38 10 15.16 11.66 14.34 14H11.22C12.14 10 15.72 7 20 7ZM20 25C15.72 25 12.14 22 11.22 18H14.34C15.16 20.34 17.38 22 20 22C22.62 22 24.84 20.34 25.66 18H28.78C27.86 22 24.28 25 20 25Z",
    fill: "url(#paint0_linear_1694_4555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1694_4555",
    x1: 9.48853e-7,
    y1: -4,
    x2: 32.6314,
    y2: 40.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer1);
export default __webpack_public_path__ + "static/media/Offer1.fc9f846f077289898bc159a60e259cbd.svg";
export { ForwardRef as ReactComponent };